import React from 'react'
import { Field } from 'redux-form'
import { InputRadio, CheckMark, RadioLabel, Radio } from './styles'

const renderFilterTypeOption = props => (
  <InputRadio
    {...props.input}
    name={props.name}
    onChange={() => props.input.onChange(props.input.value)}
    value={props.input.value}
    type="radio"
  />
)

function PeriodOption(props) {
  const { label, name, value } = props

  return (
    <RadioLabel>
      {label}
      <Field component={renderFilterTypeOption} name={name} type="radio" value={value} />
      <CheckMark />
      <Radio />
    </RadioLabel>
  )
}

export default PeriodOption



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PaginationSelector/PeriodOption.js